import { TagDisplayTypeEnum, TagIndicatorTypes } from 'src/types';
import { TagType } from '../types/types';

export const getTagDisplayType = (
  indicator: TagIndicatorTypes | null | undefined,
  tag: TagType
): TagDisplayTypeEnum => {
  if (indicator === TagIndicatorTypes.AlarmOn || indicator === TagIndicatorTypes.AlarmOff) {
    return TagDisplayTypeEnum.ALARM_INDICATOR;
  }

  // Currently the only way to check if an input is for a state, mode, or any other type of asset property is to check the raw tag name suffix, since that is consistent
  if (tag.assetId && tag.rawInputName.endsWith('_State')) {
    return TagDisplayTypeEnum.ASSET_STATE_INDICATOR;
  }

  return TagDisplayTypeEnum.VALUE_INDICATOR;
};
